module.exports = __webpack_public_path__ + "static/media/eh.eac780d1.svg";